import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import useChatbotConfig from "../../hooks/useChatbotConfig";

const Tabs = ({ type, tabSelected, idForm = "" }) => {
  const { idBroadcast = "" } = useParams();
  const { botPlan } =
    useChatbotConfig();
  
  const data = {
    admin: [
      {
        name: "Chatbots",
        path: "/admin/bots",
      },
      {
        name: "Conexiones de Usuario",
        path: "/admin/users",
      },
      {
        name: "Plantillas de WhatsApp",
        path: "/admin/templates",
      },
      {
        name: "Alertas del Sistema",
        path: "/admin/system-alerts",
      },
      {
        name: "Publicación de Novedades",
        path: "/admin/news",
      },
    ],
    reactivation: [
      {
        name: "Detalles del Proceso",
        path: "/massive/reactivation/details",
      },
      {
        name: "Historial de Solicitudes",
        path: "/massive/reactivation/history",
      },
    ],
    responses: [
      {
        name: "Respuestas Principales",
        path: "/responses",
      },
      {
        name: "Respuestas Secundarias",
        path: "/responses/secondary",
      },
    ],
    productForm: botPlan?.ai_model ? [
      {
        name: "Características",
        path: "/forms/products/" + idForm,
      },
      {
        name: "Inventario",
        path: "/forms/products/inventory/" + idForm,
      },
      {
        name: "Orden",
        path: "/forms/products/reorder/" + idForm,
      },
      {
        name: "Ejemplos",
        path: "/forms/products/examples/" + idForm,
      },
      {
        name: "Sinónimos",
        path: "/forms/products/synonyms/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/products/settings/" + idForm,
      },
    ] : [
      {
        name: "Características",
        path: "/forms/products/" + idForm,
      },
      {
        name: "Inventario",
        path: "/forms/products/inventory/" + idForm,
      },
      {
        name: "Orden",
        path: "/forms/products/reorder/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/products/settings/" + idForm,
      },
    ],
    formSchema: botPlan?.ai_model ? [
      {
        name: "Esquema",
        path: "/forms/schema/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/schema/settings/" + idForm,
      },
    ] : [
      {
        name: "Esquema",
        path: "/forms/schema/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/schema/settings/" + idForm,
      },
    ],
    branchForm: botPlan?.ai_model ? [
      {
        name: "Ramas",
        path: "/forms/branches/" + idForm,
      },
      {
        name: "Preguntas",
        path: "/forms/branches/questions/" + idForm,
      },
      {
        name: "Ejemplos",
        path: "/forms/branches/examples/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/branches/settings/" + idForm,
      },
    ] : [
      {
        name: "Ramas",
        path: "/forms/branches/" + idForm,
      },
      {
        name: "Preguntas",
        path: "/forms/branches/questions/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/branches/settings/" + idForm,
      },
    ],
    surveyForm: [
      {
        name: "Preguntas",
        path: "/forms/survey/" + idForm,
      },
      {
        name: "Compartir",
        path: "/forms/survey/links/" + idForm,
      },
      {
        name: "Difusión",
        path: "/forms/survey/send/" + idForm,
      },
      {
        name: "Configuración",
        path: "/forms/survey/settings/" + idForm,
      },
    ],
    analytics: botPlan?.ai_model ? [
      {
        name: "Conversaciones",
        path: "/analytics",
      },
      {
        name: "Mensajes",
        path: "/analytics/messages",
      },
      {
        name: "Plantillas de WhatsApp",
        path: "/analytics/messages/templates",
      },
      {
        name: "Evaluación de Conversaciones",
        path: "/analytics/chats-evaluation",
      },
      {
        name: "Intenciones",
        path: "/analytics/intents",
      },
      {
        name: "Formularios",
        path: "/analytics/forms",
      },
    ] : [
      {
        name: "Conversaciones",
        path: "/analytics",
      },
      {
        name: "Mensajes",
        path: "/analytics/messages",
      },
    ],
    advanced: botPlan?.ai_model
      ? [
        {
          name: "Ejemplos",
          path: "/advanced/examples",
        },
        {
          name: "Entidades",
          path: "/advanced/entities",
        },
        {
          name: "Intenciones",
          path: "/advanced/intents",
        },
        {
          name: "Variables",
          path: "/advanced/variables",
        },
      ]
      : [
        {
          name: "Entidades",
          path: "/advanced/entities",
        },
      ],
    campaign: [
      {
        name: "Nueva Difusión",
        path: "/campaign",
      },
      {
        name: "Registro",
        path: "/campaign/history",
      },
      {
        name: "Administrador de Plantillas",
        path: "/campaign/templates",
      },
    ],
    selectedCampaign: [
      {
        name: "Información General",
        path: idBroadcast
          ? "/campaign/general-data/" + idBroadcast
          : "/campaign/general-data",
      },
      {
        name: "Detalle de Remitente",
        path: idBroadcast
          ? "/campaign/sender-details/" + idBroadcast
          : "/campaign/sender-details",
      },
    ],
    contacts: [
      {
        name: "Contactos",
        path: "/contacts",
      },
      {
        name: "Grupos",
        path: "/contacts/groups",
      },
      {
        name: "Áreas",
        path: "/contacts/areas",
      },
      {
        name: "Registro",
        path: "/contacts/register",
      },
    ],
    settings: [
      {
        name: "General",
        path: "/settings/general",
      },
      {
        name: "Live Chat",
        path: "/settings/attention",
      },
      {
        name: "Webchat",
        path: "/settings/webchat",
      },
      {
        name: "Notificaciones",
        path: "/settings/notifications",
      },
      {
        name: "Acceso",
        path: "/settings/access",
      },
      {
        name: "Usuarios",
        path: "/settings/admin",
      },
      {
        name: "Presupuestos",
        path: "/settings/budget",
      },
    ],
  };
  const [tab, setTab] = useState(tabSelected);
  const handleChange = (tab) => {
    setTab(tab);
  };
  if (!data[type] || data[type].lenght === 0) {
    return <div></div>;
  }
  return (
    <div className="tabContainer row">
      {data[type].map((col, index) => {
        return (
          <Link
            to={col.path}
            key={index}
            className={tab === index ? "col tab selected" : "col tab"}
            onClick={() => {
              handleChange(index);
            }}
            aria-label="page-tab"
          >
            <div className="justify-content-center align-items-center">
              <p style={{ fontSize: "1.1rem" }}>{col.name}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default Tabs;
